/**
 * Identity
 *
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

export enum Channels {
  NUMBER_1 = 1,

  NUMBER_2 = 2,

  NUMBER_3 = 3,
}
